(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["package_switcher"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function activate(root, id) {
      var tabs = root.querySelectorAll('[data-package-tab]');
      var panels = root.querySelectorAll('[data-package-panel]');
      tabs.forEach(function (tab) {
        var isActive = tab.getAttribute('data-package-tab') === id;
        tab.classList.toggle('is-active', isActive);
        tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
        tab.setAttribute('tabindex', isActive ? '0' : '-1');
      });
      panels.forEach(function (panel) {
        var isActive = panel.getAttribute('data-package-panel') === id;
        panel.classList.toggle('is-active', isActive);
        if (isActive) {
          panel.removeAttribute('hidden');
        } else {
          panel.setAttribute('hidden', '');
        }
      });
    }

    function initSwitcher(root) {
      if (root.dataset.psInitialized === 'true') return;
      root.dataset.psInitialized = 'true';

      var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-package-tab]'));

      tabs.forEach(function (tab, index) {
        tab.addEventListener('click', function () {
          activate(root, tab.getAttribute('data-package-tab'));
        });
        tab.addEventListener('keydown', function (event) {
          var newIndex = null;
          if (event.key === 'ArrowRight' || event.key === 'Right') {
            newIndex = (index + 1) % tabs.length;
          } else if (event.key === 'ArrowLeft' || event.key === 'Left') {
            newIndex = (index - 1 + tabs.length) % tabs.length;
          } else if (event.key === 'Home') {
            newIndex = 0;
          } else if (event.key === 'End') {
            newIndex = tabs.length - 1;
          }
          if (newIndex !== null) {
            event.preventDefault();
            var next = tabs[newIndex];
            activate(root, next.getAttribute('data-package-tab'));
            next.focus();
          }
        });
      });
    }

    function initAll(scope) {
      var roots = (scope || document).querySelectorAll('.PackageSwitcher');
      roots.forEach(initSwitcher);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { initAll(); });
    } else {
      initAll();
    }

    // Shopify theme editor: re-init on section load and follow block selection
    document.addEventListener('shopify:section:load', function (event) {
      initAll(event.target);
    });

    document.addEventListener('shopify:block:select', function (event) {
      var blockEl = event.target;
      var root = blockEl.closest('.PackageSwitcher');
      if (!root) return;
      var panel = blockEl.closest('[data-package-panel]');
      if (panel) {
        activate(root, panel.getAttribute('data-package-panel'));
      } else if (blockEl.hasAttribute('data-package-tab')) {
        activate(root, blockEl.getAttribute('data-package-tab'));
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
